<div
  [ngClass]="{
    'desk:h-[178px] desk:w-[425px] desk:grid-cols-[auto_126px_126px] desk:self-auto desk:px-2': !forceMobileDisplay(),
  }"
  class="relative grid h-[156px] w-[357px] grid-cols-[auto_112px_112px] items-center self-center pr-2 font-title">
  @defer (on idle; on timer(5s)) {
    <!-- The 425x178 desktop box letterboxes the 357x156 drawing: at left-0 its frame would touch the last column. -->
    <div [ngClass]="{ 'desk:left-2': !forceMobileDisplay() }" class="absolute left-0 top-0">
      @if (forceMobileDisplay()) {
        <app-svg src="assets/svgs/bg-review-badge.svg" [height]="156" [width]="357" />
      } @else {
        <app-svg class="hidden desk:block" src="assets/svgs/bg-review-badge.svg" [height]="178" [width]="425" />
        <app-svg class="desk:hidden" src="assets/svgs/bg-review-badge.svg" [height]="156" [width]="357" />
      }
    </div>
  }
  <div class="flex items-center justify-center">
    <div [ngClass]="{ 'desk:size-[76px]': !forceMobileDisplay() }" class="relative size-[62px]">
      <app-svg src="assets/logos/svg/google.svg" />
    </div>
  </div>
  <div
    [ngClass]="{ 'desk:h-[160px]': !forceMobileDisplay() }"
    class="flex h-[142px] rotate-[-5deg] flex-col items-center justify-center rounded-[35px] bg-anis leading-[45px]">
    <span class="text-[65px]">{{ reviewStats().averageRating || 0 | number: "1.1-1" }}</span>
    <span class="text-[35px]">{{ "COMPONENT.AVIS-GOOGLE.OUT_OF" | translate }} 5</span>
  </div>
  <div
    [ngClass]="{ 'desk:h-[160px]': !forceMobileDisplay() }"
    class="z-10 flex h-[142px] w-full flex-col items-center justify-center rounded-[35px] bg-black leading-[33px] text-white">
    <span [ngClass]="{ 'desk:text-[35px]': !forceMobileDisplay() }" class="text-[32px]">{{
      reviewStats().totalReviews || 0 | number: "1.0-0"
    }}</span>
    <span class="font-title-alt text-[35px]">{{ "COMPONENT.AVIS-GOOGLE.REVIEWS" | translate }}</span>
  </div>
</div>
